import styled from 'styled-components'

export const BottomContent = styled.div`
	margin-top: 32px;
`
